import { render, staticRenderFns } from "./GenericPage.vue?vue&type=template&id=879381c6"
import script from "./GenericPage.vue?vue&type=script&lang=ts"
export * from "./GenericPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports